import styled from 'styled-components';
import {
  User as DefaultUser,
  House as DefaultHouse,
  UserFrame as DefaultUserFrame,
  OutlinedCard as DefaultOutlinedCard,
  Title as DefaultTitle,
  Row,
  Text,
} from '~components';

export const Container = styled.section`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-top: ${({ theme }) => theme.spacing.km10};
`;

export const Greeting = styled(DefaultTitle)`
  display: flex;
  white-space: nowrap;
`;

export const Name = styled.span`
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Description = styled(Text)`
  letter-spacing: '-0.03em';
  margin-bottom: ${({ theme }) => theme.spacing.km5};
`;

export const OutlinedCard = styled(DefaultOutlinedCard)`
  border-color: ${({ theme }) => theme.color.border.neutral.medium};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${({ theme }) => theme.spacing.km6};
  margin-bottom: ${({ theme }) => theme.spacing.km8};
`;

export const ListTitle = styled(Text)`
  display: block;
  text-align: center;
  letter-spacing: -0.03em;
  margin-top: ${({ theme }) => theme.spacing.km2};
  margin-bottom: ${({ theme }) => theme.spacing.km4};
`;

export const ListItemGroup = styled(Row)`
  margin-bottom: ${({ theme }) => theme.spacing.km6};
`;

export const ListItem = styled.li`
  display: flex;
  flex: 1;
  font-weight: ${({ theme }) => theme.font.weight.bold};
  font-size: ${({ theme }) => theme.font.size.m3};
  line-height: ${({ theme }) => theme.font.lineHeight.small};
  color: ${({ theme }) => theme.color.text.neutral.default};
  list-style: none;
  letter-spacing: -0.03em;
`;

export const List = styled.ul``;

export const User = styled(DefaultUser)`
  color: ${({ theme }) => theme.color.icon.neutral.default};
  margin-top: auto;
  margin-bottom: auto;
  margin-right: ${({ theme }) => theme.spacing.km4};
`;

export const House = styled(DefaultHouse)`
  margin-top: auto;
  margin-bottom: auto;
  margin-right: ${({ theme }) => theme.spacing.km4};
`;

export const UserFrame = styled(DefaultUserFrame)`
  color: ${({ theme }) => theme.color.icon.neutral.default};
  margin-top: auto;
  margin-bottom: auto;
  margin-right: ${({ theme }) => theme.spacing.km4};
`;
